export default __webpack_public_path__ + "static/media/background.02386a30.png";